import { useSearchParams } from "next/navigation";

import { QueryUtmParams } from "@/types/utmParams";

import { setMarketingData } from "@/services/config";

export const useUtmParams = () => {
  const searchParams = useSearchParams();

  const utmi_campaign = searchParams?.get("utmi_campaign"),
    utm_campaign = searchParams?.get("utm_campaign"),
    utm_medium = searchParams?.get("utm_medium"),
    utm_source = searchParams?.get("utm_source"),
    utmi_part = searchParams?.get("utmi_part"),
    utmi_page = searchParams?.get("utmi_page"),
    coupon = searchParams?.get("coupon");

  const queries = {
    ...(utmi_campaign && { utmi_campaign }),
    ...(utm_campaign && { utm_campaign }),
    ...(utm_medium && { utm_medium }),
    ...(utm_source && { utm_source }),
    ...(utmi_part && { utmi_part }),
    ...(utmi_page && { utmi_page }),
    ...(coupon && { coupon })
  };

  const getUtmParams = (query: QueryUtmParams) => {
    query = query || {};

    const utmParams = {
      utmiCampaign: `${query.utmi_campaign}`,
      utmCampaign: `${query.utm_campaign}`,
      utmMedium: `${query.utm_medium}`,
      utmSource: `${query.utm_source}`,
      utmiPart: `${query.utmi_part}`,
      utmiPage: `${query.utmi_page}`,
      coupon: `${query.coupon}`
    } as any;

    Object.keys(utmParams).forEach(
      (key) => utmParams[key] === "undefined" && delete utmParams[key]
    );
    return utmParams;
  };

  const postUtmParams = async (
    { utmParams }: { utmParams: any },
    cartId: string
  ) => {
    const data = await setMarketingData(cartId, utmParams);
    return data;
  };

  const utmParams = async (cartId: string) => {
    const hasQueries = !(Object.keys(queries).length === 0);

    if (hasQueries) {
      const utmParamsAndCartId = await getEssentialsUtmParams(queries);

      await postUtmParams(utmParamsAndCartId, cartId);
    }
  };

  const getEssentialsUtmParams = async (query: QueryUtmParams) => {
    const utmParams = getUtmParams(query);

    return { utmParams };
  };

  return {
    utmParams: utmParams || (() => {})
  };
};
